



































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Court from "../../store/entities/booking/court";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import Ajax from "../../lib/ajax";
// import { Survey } from "../../lib/tinymce-initial-value";

TinymceInit.height = 300;

@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class EditCourt extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  court: Court = new Court();
  titles = ["全部设施", "已选设施"];
  targetKeys: any = [];

  tinymceInit = TinymceInit;
  regions: any = [];
  selectedRegions: any = [];
  list: any = [];
  mockData: any = [];
  get extData() {
    return {
      courtId: this.court.id,
    };
  }

  handleChange(newTargetKeys) {
    this.targetKeys = newTargetKeys;
  }
  // survey = Survey;
  onCourtImageDeleted(id) {
    Ajax.delete("/api/services/app/CourtImage/Delete?id=" + id)
      .then(() => {})
      .catch(() => {
        this.$Message.error("球场图片删除失败");
      });
  }
  // async getCasCadeData() {
  //   let reponse = await Ajax.get("/api/services/app/Region/GetCasCadeData", {
  //     params: {},
  //   });
  //   this.regions = reponse.data.result;
  // }
  renderItem(item) {
    return item.label;
  }

  async validateRegionId(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择地区"));
    }
  }
  async getAllList() {
    let res = await Ajax.get("/api/services/app/CourtInstallation/GetAllList");
    this.list = res.data.result;
    let mockData = [];
    for (let i = 0; i < this.list.length; i++) {
      mockData.push({
        key: this.list[i].value.toString(),
        label: this.list[i].label,
      });
    }
    this.mockData = mockData;
  }
  async getListByCourtId(courtId) {
    let res = await Ajax.get(
      "/api/services/app/CourtFacilityAssoc/GetListByCourtId",
      {
        params: {
          courtId,
        },
      }
    );
    let list = res.data.result;
    if (list && list.length > 0) {
      let listValues = new Set(list.map((item) => item.toString()));
      let filteredMockData = this.mockData.filter((item) =>
        listValues.has(item.key)
      );
      this.targetKeys = filteredMockData.map((item) => item.key);
    }
  }

  save() {
    (this.$refs.courtForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "court/updateWithImages",
          data: {
            court: this.court,
            images: this.court.courtImages,
            courtFacilityAss: this.targetKeys,
          },
        });
        this.$Message.success({
          content: "修改球场信息成功",
        });
        (this.$refs.courtForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }

  cancel() {
    (this.$refs.courtForm as any).resetFields();
    this.$emit("input", false);
  }

  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      // this.getMockData();
      this.court = Util.extend(true, {}, this.$store.state.court.editCourt);
      await this.getAllList();
      await this.getListByCourtId(this.court.id);
      // await this.getCasCadeData();
    }
  }

  async validateCourtImages(rule, value, callback) {
    if (value.length == 0) {
      callback(new Error("请上传球场图片"));
    }
  }
  async validateLongitude(rule, value, callback) {
    if (!this.court.longitude) {
      callback(new Error("请填写经度"));
    }
  }
  async validateLatitude(rule, value, callback) {
    if (!this.court.latitude) {
      callback(new Error("请填写纬度"));
    }
  }
  async validateTunnelNumber(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入球场洞数"));
    }
  }
  async validatePpeningTime(rule, value, callback) {
    if (!this.court.openingTime) {
      callback(new Error("请选择开业时间"));
    }
  }
  async validateDistance(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入距离"));
    }
  }
  courtRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("CourtName")),
        trigger: "blur",
      },
      {
        type: "string",
        max: 256,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("CourtName"),
          "256"
        ),
        trigger: "blur",
      },
    ],
    address: [
      {
        required: true,
        type: "string",
        max: 512,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("Address"),
          "512"
        ),
        trigger: "blur",
      },
    ],
    // tunnelNumber: [
    //   {
    //     required: true,
    //     type: "number",
    //     validator: this.validateTunnelNumber,
    //     message: "请输入洞数",
    //     trigger: "blur change",
    //   },
    // ],
    // par: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入标准杆",
    //     trigger: "blur",
    //   },
    // ],
    // distance: [
    //   {
    //     required: true,
    //     type: "number",
    //     validator: this.validateDistance,
    //     message: "请输入距离",
    //     trigger: "blur change",
    //   },
    // ],
    // difficulty: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入难度",
    //     trigger: "blur",
    //   },
    // ],
    // slope: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入坡度",
    //     trigger: "blur",
    //   },
    // ],
    // courtStyle: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入风格",
    //     trigger: "blur",
    //   },
    // ],
    // designer: [
    //   {
    //     required: true,
    //     type: "string",
    //     message: "请输入设计师",
    //     trigger: "blur",
    //   },
    // ],
    openingTime: [
      {
        required: true,
        validator: this.validatePpeningTime,
        message: "选择开业时间",
        trigger: "change",
      },
    ],
    phoneNumber: [
      {
        required: true,
        type: "string",
        message: "请输入手机号",
        trigger: "blur",
      },
    ],
    installations: [
      {
        required: true,
        // pattern: /^([+-]?)\d*\.\d+$/,
        message: "请填写球场设施",
        trigger: "blur",
      },
    ],
    regionId: [
      {
        required: true,
        validator: this.validateRegionId,
        trigger: "change",
      },
    ],
    // longitude: [
    //   {
    //     required: true,
    //     type: 'string',
    //     // pattern: /^[-+]?([1-9]|[1-9]\d|1[0-7]\d|180)(\.\d+)?$/,
    //     validator: this.validateLongitude,
    //     trigger: "blur",
    //   },
    // ],
    // latitude: [
    //   {
    //     required: true,
    //     type:"string",
    //     // pattern: /^([+-]?)\d*\.\d+$/,
    //     message: "请填写纬度",
    //     validator: this.validateLatitude,
    //     trigger: "blur",
    //   },
    // ],
    courtImages: [
      {
        required: true,
        validator: this.validateCourtImages,
        trigger: "change",
      },
    ],
  };
}
